import { getReportByIdApi } from '@intelligence/services/reportService';
import { getPresentationReport } from '@home/services/studio';
import { pageReportTypeConfig } from '@intelligence/_config/reportConfig';

interface IUseReportDeletedCheckProps {
  executable: boolean;
  systemId: string;
  studioId?: string;
  resourceId: string;
}

const getReport = async (systemId: string, studioId?: string, id?: string) => {
  if (!id) {
    return null;
  }

  if (systemId === pageReportTypeConfig.studioReport.systemIdCur) {
    const res: any = await getPresentationReport({ studio_id: studioId || '' });
    const report = res?.resource_list?.find((report: any) => report?.resource_id === id);
    return {
      ...res,
      resource_list: report ? [report] : [],
    };
  }

  return getReportByIdApi({ resource_ids: [id] });
};

/**
 * 报告删除检测 hook
 * 通过调用 getReport 检测报告是否被删除
 * @returns checkReportDeleted 检测函数，返回 true 表示报告被删除
 */
export default function useReportDeletedCheck(props: IUseReportDeletedCheckProps) {
  const { executable, systemId, studioId, resourceId } = props;

  const checkReportDeleted = async (): Promise<boolean> => {
    if (!executable) return false;
    if (!resourceId) return false;

    try {
      const res = await getReport(systemId, studioId, resourceId);
      const reportDetails = res?.resource_list?.[0];
      // 如果 reportDetails 为空，说明报告已被删除
      return !reportDetails;
    } catch (error) {
      console.error('Failed to check report deleted status:', error);
      // 接口调用失败时，不认为是删除状态，让原有流程继续执行
      return false;
    }
  };

  return { checkReportDeleted };
}
